import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const SHOP_API = `${BACKEND_URL}/api`;
export const SHOP_TOKEN_KEY = "bmf_shop_token";
export const SHOP_ACCT_KEY = "bmf_shop_account";
export const SHOP_CART_KEY = "bmf_shop_cart";

export const shopApi = axios.create({ baseURL: SHOP_API });

shopApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(SHOP_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

shopApi.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (Array.isArray(detail)) {
      const msg = detail.map((d) => (typeof d === "string" ? d : d.msg || JSON.stringify(d))).join("; ");
      err.response.data.detail = msg;
    }
    return Promise.reject(err);
  },
);

// -------- Shop auth helpers --------
export function getShopAccount() {
  try { return JSON.parse(localStorage.getItem(SHOP_ACCT_KEY) || "null"); } catch { return null; }
}
export function setShopAccount(a) {
  if (a) localStorage.setItem(SHOP_ACCT_KEY, JSON.stringify(a));
  else localStorage.removeItem(SHOP_ACCT_KEY);
}
export function getShopToken() {
  return localStorage.getItem(SHOP_TOKEN_KEY);
}
export function shopLogout() {
  localStorage.removeItem(SHOP_TOKEN_KEY);
  localStorage.removeItem(SHOP_ACCT_KEY);
  localStorage.removeItem(SHOP_CART_KEY);
}

// -------- Cart (localStorage) --------
export function getCart() {
  try { return JSON.parse(localStorage.getItem(SHOP_CART_KEY) || "[]"); } catch { return []; }
}
export function saveCart(items) {
  localStorage.setItem(SHOP_CART_KEY, JSON.stringify(items || []));
}
export function addToCart(product, qty) {
  const cart = getCart();
  const idx = cart.findIndex((c) => c.product_id === product.id);
  if (idx >= 0) cart[idx].quantity = Number(cart[idx].quantity) + Number(qty);
  else cart.push({
    product_id: product.id,
    name: product.name,
    sku: product.sku,
    quantity: Number(qty),
    unit_price_preview: product.unit_price_preview,
    base_price: product.base_price,
    gst_rate: product.gst_rate,
    b2b_bulk_tiers: product.b2b_bulk_tiers || [],
    customer_discount_pct: product.customer_discount_pct || 0,
  });
  saveCart(cart);
  return cart;
}
export function updateCartQty(product_id, quantity) {
  const cart = getCart().map((c) => (c.product_id === product_id ? { ...c, quantity: Number(quantity) } : c))
                        .filter((c) => Number(c.quantity) > 0);
  saveCart(cart);
  return cart;
}
export function removeFromCart(product_id) {
  const cart = getCart().filter((c) => c.product_id !== product_id);
  saveCart(cart);
  return cart;
}
export function computeLineTotals(item) {
  // Recompute unit price based on cart quantity + bulk tiers, honouring customer_discount_pct baseline.
  const base = Number(item.base_price || 0);
  const tiers = (item.b2b_bulk_tiers || []).slice().sort((a, b) => Number(a.min_qty) - Number(b.min_qty));
  let bulkPct = 0;
  for (const t of tiers) if (Number(item.quantity) >= Number(t.min_qty)) bulkPct = Number(t.discount_pct);
  const custPct = Number(item.customer_discount_pct || 0);
  const unit = Number((base * (1 - custPct / 100) * (1 - bulkPct / 100)).toFixed(2));
  const line = Number((unit * Number(item.quantity)).toFixed(2));
  const gst = Number((line * Number(item.gst_rate || 0) / 100).toFixed(2));
  return { unit, line, gst, total: Number((line + gst).toFixed(2)), bulkPct, custPct };
}
